import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Grid from '@material-ui/core/Grid';

import * as reducers from '../reducer/ReportSearchForm';

import * as actionMgr from '../aciton-mgr/ReportSearchForm';
import * as errorReportActionMgr from '../aciton-mgr';

import SearchBox from '../../common-components/SearchBox';
import FlexOne from '../../common-components/FlexOne';

import * as strings from '../../helpers/strings';
import { getUserId } from '../../helpers/common';

import LoadingOverlay from '../../common-components/LoadingOverlay';
// import Page from '../../common-components/Page';
// import { Paper } from '@material-ui/core';

const styles = {
  root: {
    marginBottom: 20
  },
  dnone: {
    display: "none"
  },
  m0: {
    margin: '0px'
  }
}

class ReportSearchForm extends Component {

  constructor() {
    super();

    this.handleOnSearchChange = this.handleOnSearchChange.bind(this);
    this.handleOnPageChange = this.handleOnPageChange.bind(this);
    this.handleSearchKeyDown = this.handleSearchKeyDown.bind(this);
  }

  componentDidMount() {
    this.handleOnPageChange(null, 0);
  }

  handleOnSearchChange(e) {
    const { setKeyword } = this.props;
    setKeyword(e.target.value);
    console.log(e.target.value)
  }

  handleOnPageChange(event, page) {
    const { rowsPerPage, bufferedKeyword, search, match } = this.props;
    search({
      keyword: match.params.stationName ? atob(match.params.stationName) : bufferedKeyword,
      userId: getUserId(),
      startIndex: page,
      size: rowsPerPage
    })
  }

  handleSearchKeyDown(e) {
    const { currentPage, rowsPerPage, search, keyword, setBufferedKeyword } = this.props;

    console.log(keyword)

    if ("Enter" === e.key) {
      search({
        keyword: keyword,
        userId: getUserId(),
        startIndex: currentPage * rowsPerPage,
        size: rowsPerPage
      });
      setBufferedKeyword(keyword);
    }
  }

  render() {
    const { keyword, classes, totalRecord, totalPages, currentPage, rowsPerPage, match, isSearching } = this.props;

    return (
      <div className={classes.root}>
        {(isSearching) && <LoadingOverlay />}
        {/* <Paper>
        <Page> */}
        <Grid container alignItems="center">
          {!match.params.stationName &&
            <Grid item md={5} sm={6} xs={12}>
              <SearchBox
                value={keyword}
                onChange={this.handleOnSearchChange}
                onKeyDown={this.handleSearchKeyDown}
                placeholder={strings.placeholderTypeRefNoOrStationId}
                fullWidth={true}
              />
            </Grid>
          }
          <FlexOne />
          <span style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)' }}> Total Page: {currentPage + 1} - {totalPages} </span>
          <TablePagination
            classes={{
              caption: classes.dnone,
              actions: classes.m0,
            }}
            component="div"
            count={totalRecord}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            backIconButtonProps={{
              'aria-label': strings.lblPreviousPage,
            }}
            nextIconButtonProps={{
              'aria-label': strings.lblNextPage,
            }}
            rowsPerPageOptions={[rowsPerPage]}
            onChangePage={this.handleOnPageChange}
          />
        </Grid>
        {/* </Page>
        </Paper> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  keyword: reducers.getKeyword(state),
  bufferedKeyword: reducers.getBufferredKeyword(state),
  totalRecord: reducers.getTotalRecord(state),
  totalPages: reducers.getTotalPages(state),
  currentPage: reducers.getCurrentPage(state),
  rowsPerPage: reducers.getRowsPerPage(state),

  isSearching: reducers.getIsSearching(state)
});

const mapActionToProps = {
  setKeyword: actionMgr.setKeyword,
  setBufferedKeyword: actionMgr.setBufferedKeyword,

  search: errorReportActionMgr.search
};

export default connect(mapStateToProps, mapActionToProps)(
  withStyles(styles)(
    withRouter(ReportSearchForm)
  )
);